import { enumToEnumNames } from '../../common-client2/src/services/enums';

const REMOVE = 'remove';
const ADD = 'add';

export const BreakRuleActionType = Object.freeze({
    [REMOVE]: 0,
    [ADD]: 1,
});

export const BreakRuleActionTypeNames = enumToEnumNames(BreakRuleActionType);

export default BreakRuleActionType;
